import { Component, DestroyRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { UserPhoneNumbersComponent } from '../user-phone-numbers/user-phone-numbers.component';
import { AiAgentResponse } from '../../../models/responses/ai-agent-response';
import { MatButtonModule } from '@angular/material/button';
import { SubscriptionHelper } from '../../../classes/subscription-helper';
import { AiConfigurationPageEventsService } from '../../../events/ai-configuration-page-events.service';

@Component({
  selector: 'app-user-phone-numbers-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatDividerModule,
    UserPhoneNumbersComponent,
    MatButtonModule
  ],
  templateUrl: './user-phone-numbers-dialog.component.html',
  styleUrl: './user-phone-numbers-dialog.component.scss'
})
export class UserPhoneNumbersDialogComponent {
  subscriptions: SubscriptionHelper;

  constructor(
    public dialogRef: MatDialogRef<UserPhoneNumbersComponent>,
    @Inject(MAT_DIALOG_DATA) public aiAgent: AiAgentResponse,
    private aiConfigurationPageEventService: AiConfigurationPageEventsService,
    private destroyRef: DestroyRef
  ){

    this.subscriptions = new SubscriptionHelper(destroyRef);
  }

  ngOnInit() {
    this.subscribeToOnPhoneNumberSelected();
  }

  subscribeToOnPhoneNumberSelected(){
    this.subscriptions.add(this.aiConfigurationPageEventService.onSelectPhoneNumberEvent.subscribe(phoneSettings => {
      this.dialogRef.close();
    }));
  }
}
